import { SxProps, Theme } from '@mui/material/styles';

export const primaryOutlinedButtonSx: SxProps<Theme> = (theme) => ({
  borderWidth: 2,
  borderStyle: 'solid',
  borderColor: theme.palette.text.primary,
  color: theme.palette.text.primary,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    borderColor: theme.palette.text.primary,
  },
  '&.Mui-disabled': {
    borderColor: theme.palette.action.disabled,
    color: theme.palette.action.disabled,
  },
});

export const secondaryOutlinedButtonSx: SxProps<Theme> = (theme) => ({
  borderWidth: 2,
  borderStyle: 'solid',
  borderColor: theme.palette.common.white,
  color: theme.palette.common.white,
  '&:hover': {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.black,
    borderColor: theme.palette.secondary.main,
  },
  '&.Mui-disabled': {
    borderColor: theme.palette.action.disabled,
    color: theme.palette.action.disabled,
  },
});
